var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRequestDeclined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "request_waiting-for-keys") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16,0V32a16.34,16.34,0,0,0,5.43-2.86,18,18,0,0,0,6.71-14.2V4.42C19.7,4.42,16,0,16,0Z",
    fill: "#ccc"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16,0S12.32,4.42,3.86,4.42V14.94a18,18,0,0,0,6.71,14.2A16.35,16.35,0,0,0,16,32h0V0h0Z",
    fill: "#ccc"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.43,3L16,2.69A18.9,18.9,0,0,1,5.86,6.34v8.61a16.09,16.09,0,0,0,5.94,12.63A14.59,14.59,0,0,0,16,29.9h0V3h0.43Z",
    fill: "#c02e1d"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.14,14.94V6.34A19.1,19.1,0,0,1,16.43,3H16V29.9a14.56,14.56,0,0,0,4.19-2.33A16.09,16.09,0,0,0,26.14,14.94Z",
    fill: "#c02e1d"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.59,15l3.58-3.58a1.12,1.12,0,1,0-1.59-1.59L16,13.41,12.42,9.83a1.12,1.12,0,0,0-1.59,1.59L14.41,15l-3.58,3.58a1.12,1.12,0,1,0,1.59,1.59L16,16.59l3.58,3.58a1.12,1.12,0,1,0,1.59-1.59Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16,0S12.32,4.42,3.86,4.42V14.94a18,18,0,0,0,6.71,14.2A16.35,16.35,0,0,0,16,32h0V0h0Z",
    opacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestDeclined);
export default __webpack_public_path__ + "static/media/request_declined.95fa6cc751dc07ea167f574209213c10.svg";
export { ForwardRef as ReactComponent };